import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';

const PAINS = [
    { id: 'time', text: "Je cours après le temps 🏃", icon: "⏳" },
    { id: 'clients', text: "Manque de clients réguliers 📉", icon: "👥" },
    { id: 'admin', text: "Noyé sous l'administratif 📄", icon: "🤯" },
    { id: 'money', text: "Trésorerie en dents de scie 💸", icon: "🎢" },
];

const DREAMS = [
    { id: 'vacation', text: "3 semaines de vacances / an 🏖️", icon: "🌴" },
    { id: 'team', text: "Embaucher mon premier salarié 🤝", icon: "👷" },
    { id: 'leader', text: "Devenir le N°1 de ma ville 🥇", icon: "🏙️" },
    { id: 'peace', text: "Rentrer chez moi à 18h zen 🧘", icon: "🏠" },
];

export default function CommercialVisionPage() {
    const navigate = useNavigate();
    const [selectedPains, setSelectedPains] = useState([]);
    const [selectedDreams, setSelectedDreams] = useState([]);
    const [showVision, setShowVision] = useState(false);

    const togglePain = (id) => {
        if (selectedPains.includes(id)) setSelectedPains(selectedPains.filter(p => p !== id));
        else setSelectedPains([...selectedPains, id]);
    };

    const toggleDream = (id) => {
        if (selectedDreams.includes(id)) setSelectedDreams(selectedDreams.filter(d => d !== id));
        else setSelectedDreams([...selectedDreams, id]);
    };

    const handleReveal = () => {
        setShowVision(true);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

            {showVision && <Confetti recycle={false} numberOfPieces={300} colors={['#fbbf24', '#f59e0b']} />}

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', maxWidth: 1000, marginBottom: 40 }}>
                <h1 style={{ fontSize: '2rem', fontWeight: 800, display: 'flex', alignItems: 'center', gap: 10 }}>🔮 Future Vision</h1>
                <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'rgba(255,255,255,0.1)', padding: '10px 20px', borderRadius: 50, border: 'none', color: 'white', cursor: 'pointer' }}>Fermer</button>
            </div>

            {!showVision ? (
                <div style={{ display: 'flex', gap: 40, width: '100%', maxWidth: 1200, flex: 1 }}>
                    {/* Left: Today */}
                    <div style={{ flex: 1, background: '#1e293b', borderRadius: 24, padding: 30, display: 'flex', flexDirection: 'column' }}>
                        <h2 style={{ fontSize: '1.5rem', opacity: 0.7, marginBottom: 20, textAlign: 'center' }}>AUJOURD'HUI 🌧️</h2>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                            {PAINS.map(pain => (
                                <div
                                    key={pain.id} onClick={() => togglePain(pain.id)}
                                    style={{
                                        padding: 20, borderRadius: 12, cursor: 'pointer', border: '2px solid',
                                        background: selectedPains.includes(pain.id) ? '#334155' : 'transparent',
                                        borderColor: selectedPains.includes(pain.id) ? '#94a3b8' : 'rgba(255,255,255,0.1)',
                                        opacity: selectedPains.includes(pain.id) ? 1 : 0.6, transition: 'all 0.2s'
                                    }}
                                >
                                    {pain.text}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Arrow */}
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '2rem', opacity: 0.3 }}>➜</div>

                    {/* Right: Tomorrow */}
                    <div style={{ flex: 1, background: 'linear-gradient(135deg, #1e293b, #312e81)', borderRadius: 24, padding: 30, display: 'flex', flexDirection: 'column', border: '1px solid #4f46e5' }}>
                        <h2 style={{ fontSize: '1.5rem', color: '#818cf8', marginBottom: 20, textAlign: 'center', fontWeight: 800 }}>DANS 1 AN ✨</h2>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                            {DREAMS.map(dream => (
                                <div
                                    key={dream.id} onClick={() => toggleDream(dream.id)}
                                    style={{
                                        padding: 20, borderRadius: 12, cursor: 'pointer', border: '2px solid',
                                        background: selectedDreams.includes(dream.id) ? 'rgba(99, 102, 241, 0.2)' : 'transparent',
                                        borderColor: selectedDreams.includes(dream.id) ? '#6366f1' : 'rgba(255,255,255,0.1)',
                                        opacity: selectedDreams.includes(dream.id) ? 1 : 0.6, transition: 'all 0.2s'
                                    }}
                                >
                                    {dream.text}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                // THE REVEAL
                <div className="animate-zoom-in" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #f59e0b, #d97706)', padding: 60, borderRadius: 40, textAlign: 'center',
                        boxShadow: '0 0 100px rgba(245, 158, 11, 0.4)', color: 'white', maxWidth: 800
                    }}>
                        <div style={{ fontSize: '1.5rem', textTransform: 'uppercase', letterSpacing: 3, marginBottom: 10, fontWeight: 700 }}>Votre Future Réalité</div>
                        <div style={{ fontSize: '4rem', fontWeight: 900, marginBottom: 40, lineHeight: 1.1 }}>
                            {selectedDreams.length > 0 ? "LEADER DIGITALE" : "SUCCÈS GARANTI"}
                        </div>

                        <div style={{ display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap' }}>
                            {selectedDreams.map(id => {
                                const dream = DREAMS.find(d => d.id === id);
                                return <div key={id} style={{ background: 'rgba(255,255,255,0.2)', padding: '10px 20px', borderRadius: 20 }}>{dream?.icon} {dream?.text}</div>
                            })}
                        </div>

                        <div style={{ width: '100%', height: 2, background: 'rgba(255,255,255,0.3)', margin: '40px 0' }} />

                        <div style={{ fontSize: '1.2rem', fontWeight: 600 }}>La seule chose qui sépare la colonne de gauche de celle de droite ?</div>
                        <div style={{ fontSize: '2rem', fontWeight: 800, marginTop: 10 }}>C'est une signature.</div>

                        <button onClick={() => navigate('/commercial/sign')} style={{ marginTop: 40, padding: '20px 50px', background: 'white', color: '#d97706', border: 'none', borderRadius: 50, fontSize: '1.5rem', fontWeight: 800, cursor: 'pointer' }}>
                            COMMENCER LA TRANSFORMATION
                        </button>
                    </div>
                </div>
            )}

            {!showVision && (
                <button
                    onClick={handleReveal} disabled={selectedDreams.length === 0}
                    style={{
                        marginTop: 40, padding: '20px 60px', borderRadius: 50, border: 'none',
                        background: selectedDreams.length > 0 ? '#4f46e5' : '#334155', color: 'white',
                        fontSize: '1.5rem', fontWeight: 800, cursor: selectedDreams.length > 0 ? 'pointer' : 'not-allowed',
                        transition: 'all 0.3s'
                    }}
                >
                    VOIR MON AVENIR 🔮
                </button>
            )}

            <style>{`.animate-zoom-in { animation: zoomIn 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275); } @keyframes zoomIn { from { transform: scale(0.8); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>
        </div>
    );
}
